import React from "react";
import PropTypes from "prop-types";

const btnBase = {
  border: "none",
  borderRadius: 6,
  padding: "3px 10px",
  fontSize: 12,
  cursor: "pointer",
  flexShrink: 0,
};

function GroupDeleteConfirm({ group, onConfirm, onCancel }) {
  return (
    <>
      <span style={{ flex: 1, fontSize: 13, color: "#374151" }}>Delete &ldquo;{group.name}&rdquo;?</span>
      <button type="button" onClick={onConfirm} className="bg-destructive-80" style={{ ...btnBase, color: "#fff" }}>
        Yes
      </button>
      <button type="button" onClick={onCancel} style={{ ...btnBase, background: "#f3f4f6", color: "#374151" }}>
        No
      </button>
    </>
  );
}

GroupDeleteConfirm.propTypes = {
  group: PropTypes.shape({ name: PropTypes.string }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GroupDeleteConfirm;
